export default __webpack_public_path__ + "static/vector-shape8-e0ba98fd8aa3b91a4d5820da99c1bdd6.png";